import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { FieldLayout } from "@/pages/ContactsPage/Components/FieldLayout";
import { FormInput, FormTextArea } from "@/shared/Components";

type Props = {
  index: number;
  onBlur?: () => void;
  onChange?: () => void;
};

export const HobbiesField = ({ index, onBlur, onChange }: Props) => {
  const { t } = useTranslation();

  const handleBlur = useCallback(() => {
    onBlur?.();
  }, [onBlur]);

  return (
    <FieldLayout>
      <FormInput
        name={`hobbies.${index}.hobbyType.name`}
        placeholder={t("contactsPage.activities.hobby")}
        onBlur={handleBlur}
        customOnChange={onChange}
      />
      <FormTextArea
        name={`hobbies.${index}.about`}
        placeholder={t("common.about")}
        onBlur={handleBlur}
      />
    </FieldLayout>
  );
};
